import React from 'react';
import { SearchPanel } from '../components/SearchPanel';
import { RequestDataTable } from '../components/RequestDataTable';
import { InstanceCombobox } from '../components/InstanceCombobox'
import logService from '../services/LogService'
import { useSelector, useDispatch } from "react-redux";
import { updateSearch, pushDetails, clearSearch, setServerInstance, updateEntries, updateLogPageNum, setCertificateLabel } from "../actions/searchAction";
import { useHistory } from "react-router-dom";




//TODO: move this code to the action handler
const updateSearchModel = (e, currentSearchMode) => {
  console.log(`Updating handleSearchParamsChange ${Object.getOwnPropertyNames(e)}`);

  var newSearchModel = Object.assign({}, currentSearchMode);
  newSearchModel.authorityName = (e.authorityName !== undefined) ? e.authorityName : newSearchModel.authorityName;
  newSearchModel.requestDate = (e.requestDate !== undefined) ? e.requestDate : newSearchModel.requestDate;
  newSearchModel.requestId = (e.requestId !== undefined) ? e.requestId : newSearchModel.requestId;
  newSearchModel.patientDob = (e.patientDob !== undefined) ? e.patientDob : newSearchModel.patientDob;
  newSearchModel.patientFirstName = (e.patientFirstName !== undefined) ? e.patientFirstName : newSearchModel.patientFirstName;
  newSearchModel.patientLastName = (e.patientLastName !== undefined) ? e.patientLastName : newSearchModel.patientLastName;
  newSearchModel.topCount = (e.topCount !== undefined) ? e.topCount : newSearchModel.topCount;
  newSearchModel.desc = (e.desc !== undefined) ? e.desc : newSearchModel.desc;
  newSearchModel.serverInstance = (e.serverInstance !== undefined) ? e.serverInstance : 'Prod'
  return newSearchModel;
}


export const RequestLogs = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();

  // Search logs for the search criteria
  const searchLogEntries = async (searchModel) => {
    console.log("searching for log entries")
    return logService.getList(searchModel);
  }

  // Download a specific request
  const getRequestDetails = async (authorityId, requestId) => {
    console.log('Requesting details');
    return logService.getDetails(authorityId, requestId);
  }

  // Download certificate for selected  row
  const downloadCertificate = (authorityId, requestId, certType, serverInstance) => {
    console.log('Requesting certificate');
    logService.getCertificate(authorityId, requestId, serverInstance, certType);
  }

  // Save the current page
  const handlePageChange = page => {
    dispatch(updateLogPageNum(page));
  };

  // Download and display a request
  const handleShowRequestDetails = (authorityId, requestId, certType) => {
    getRequestDetails(authorityId, requestId)
      .then((data) => {
        if (data !== null) {
          dispatch(setCertificateLabel(certType));
          dispatch(pushDetails(data));
          history.push('/details');
        }
      })
      .catch((error) => {
        console.error(`Could not get products: ${error}`);
      });
  };

  // Handle a search reuest
  const handleSearchClick = (e) => {
    searchLogEntries(state.searchModel)
      .then((data) => {
        dispatch(updateEntries(data))
      })
      .catch((error) => {
        console.error(`Could not get request entries: ${error}`);
      });
  };
  const handleChangeServerInstance = (e) => dispatch(setServerInstance(e));
  const handleSearchChanges = (e) => dispatch(updateSearch(updateSearchModel(e, state.searchModel)));
  const searchButtonClass = (state.searchModel.authorityName !== '') ? 'btn btn-primary' : 'btn btn-primary disabled';
  const searchButtonEnabled = (state.searchModel.authorityName !== '') ? '' : 'disabled';

  return (
    <>
      <h1>Immucert Request Logs</h1>
      <div className='row'>
        <div className='col-md-6'>
          <p>Enter a search filter to view the logs.</p>
        </div>
        <div className='col-md-2 offset-md-2 '>
          <InstanceCombobox
            selectedInstance={state.serverInstance}
            onChangeState={handleChangeServerInstance} />
        </div>
        <div className='col-md-2 btn-group'>
          <button
            className={searchButtonClass}
            disabled={searchButtonEnabled}
            onClick={handleSearchClick}>Search</button>
        </div>
      </div>

      <SearchPanel
        style={{ zIndex: 1000 }}
        searchParams={state.searchModel}
        handleChangeProps={handleSearchChanges} />
      <br />
      <RequestDataTable
        data={state.data}
        currentPage={state.currentLogPage }
        serverInstance={state.serverInstance}
        onChangePage={handlePageChange}
        handleShowRequestDetails={handleShowRequestDetails}
        handleDownloadCertificate={downloadCertificate}
      />
    </>
  );
}
